export default "__VITE_ASSET__3QCSx3np__"